import React, { useEffect, useState } from 'react';
import { Button, Modal, Form } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { retriggerPropagation } from '../../../../Redux/recordPropagation/action';

const RetriggerPropagationModal = ({ show, onClose, row, onSuccess }) => {
    const [remarks, setRemarks] = useState('');
    const [remarksError, setRemarksError] = useState('');
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        if (show) {
            setRemarks('');
            setRemarksError('');
            setSubmitting(false);
        }
    }, [show]);

    const recordId = row?.id ?? row?.pk;
    const targetJobId = row?.propagate_job;

    const handleClose = () => {
        if (submitting) return;
        onClose && onClose();
    };

    const handleSubmit = () => {
        if (submitting) return;
        if (!remarks?.trim()) {
            setRemarksError('Remarks are required');
            return;
        }
        setRemarksError('');
        setSubmitting(true);

        retriggerPropagation({ id: recordId, remarks: remarks.trim() })((response) => {
            setSubmitting(false);
            if (response?.status) {
                Swal.fire({
                    title: 'Success',
                    text: response?.message || 'Propagation retrigger initiated successfully.',
                    icon: 'success',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#6ba2b6',
                }).then(() => {
                    onClose && onClose();
                    onSuccess && onSuccess();
                });
            } else {
                Swal.fire({
                    title: 'Error',
                    text: response?.message || 'Failed to retrigger propagation.',
                    icon: 'error',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#6ba2b6',
                });
            }
        });
    };

    return (
        <Modal show={show} onHide={handleClose} centered backdrop={submitting ? 'static' : true}>
            <Modal.Header closeButton={!submitting}>
                <Modal.Title>Retrigger Propagation Request</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="alert alert-warning" role="alert">
                    Are you sure you want to retrigger this propagation request? If the process is initiated, the existing data associated with Target Job: <strong>{targetJobId || '-'}</strong> may be removed or replaced.
                </div>
                <Form.Group>
                    <Form.Label style={{ fontWeight: 600 }}>Remarks <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={3}
                        value={remarks}
                        onChange={(e) => { setRemarks(e.target.value); if (remarksError) setRemarksError(''); }}
                        isInvalid={!!remarksError}
                        className="form-control-solid"
                        placeholder="Enter remarks"
                        disabled={submitting}
                    />
                    <Form.Control.Feedback type="invalid">{remarksError}</Form.Control.Feedback>
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="light" onClick={handleClose} disabled={submitting}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleSubmit} disabled={submitting}>
                    {submitting ? 'Retriggering...' : 'Retrigger'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default RetriggerPropagationModal;
